'use client';

import React from 'react';
import { Box } from '@mui/material';
import { FileText } from 'lucide-react';
import { StatsCard, ColoredDot } from "@crm-src/components/stats-card";
import type { InvoiceStats } from '@crm-src/lib/store/invoicesSlice';

interface DocumentStatsCardsProps {
  stats: InvoiceStats | null;
  documentType: 'invoice' | 'quote';
}

export function DocumentStatsCards({ stats, documentType }: DocumentStatsCardsProps) {
  const isQuote = documentType === 'quote';

  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(4, 1fr)" }, gap: 2 }}>
      <StatsCard
        title={`Total ${isQuote ? 'Quotes' : 'Invoices'}`}
        value={stats?.total_invoices || 0}
        icon={FileText}
        iconColor="text-blue-600"
      />
      {!isQuote && (
        <>
          <StatsCard
            title="Overdue"
            value={stats?.overdue_invoices || 0}
            valueColor="text-red-600"
            customIcon={<ColoredDot color="bg-red-100" />}
          />
          <StatsCard
            title="Pending"
            value={(stats?.unpaid_invoices || 0) - (stats?.overdue_invoices || 0)}
            valueColor="text-yellow-600"
            customIcon={<ColoredDot color="bg-yellow-100" />}
          />
          <StatsCard
            title="Paid"
            value={stats?.paid_invoices || 0}
            valueColor="text-green-600"
            customIcon={<ColoredDot color="bg-green-100" />}
          />
        </>
      )}
      {isQuote && (
        <>
          <StatsCard
            title="Pending"
            value={stats?.unpaid_invoices || 0}
            valueColor="text-yellow-600"
            customIcon={<ColoredDot color="bg-yellow-100" />}
          />
          <StatsCard
            title="Converted"
            value={stats?.paid_invoices || 0}
            valueColor="text-green-600"
            customIcon={<ColoredDot color="bg-green-100" />}
          />
          <StatsCard
            title="Expired"
            value={stats?.overdue_invoices || 0}
            valueColor="text-red-600"
            customIcon={<ColoredDot color="bg-red-100" />}
          />
        </>
      )}
    </Box>
  );
}


